module.exports = __webpack_public_path__ + "static/media/agriculture.1e8ab14d.jpg";